import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { HOST } from "common-import/constants";
import { Request, VarHelper } from "common-import/helpers";

export default class UploadImageModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    list: PropTypes.array,
  };

  constructor(props) {
    super (props);

    this.state = {
      open: false,
      input: '',
      files: [],
      images: [],
      uploading: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.handleRemove = this.handleRemove.bind(this, 'index');
    this.handleFilesChange = this.handleFilesChange.bind(this);
  }

  handleRemove = (index) => {
    // e.preventDefault();
    const { images } = this.state;
    const clone = images.filter((item, key) => {
      if (index !== key) {
        return item;
      }
    });
    this.setState({ images: clone });
  };

  handleFilesChange = (e) => {
    const { files, images } = this.state;
    const newFiles = e.target.files;
    const newImages = this.getUrls(newFiles);
    this.setState({
      images: [...images, ...newImages],
      files: [...files, ...newFiles],
    })
  };

  getUrls = (items) => {
    const urls = [];
    for (let i = 0; i < items.length; i++) {
      urls.push(URL.createObjectURL(items[i]));
    }
    return urls;
  };

  handleUpload = async () => {
    // e.preventDefault();
    let newImages;
    const { files, images } = this.state;
    newImages = images.filter((item) => {
      if (item.indexOf('blob') === -1) {
        return item;
      }
    });
    for (let i = 0; i < files.length; i++) {
      const uploadedUrl = await Request.upload(files[i]);
      newImages.push(uploadedUrl);
    }
    this.setState({
      files: [],
      images: newImages
    });
    return newImages;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ uploading: true });
    const data = await this.handleUpload();
    this.setState({ uploading: false });
    this.props.onSubmit(data);
  };

  onClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  componentDidUpdate(prevProps) {
    const { open, list } = this.props;
    if (open !== prevProps.open) {
      let clone = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        clone.push(VarHelper.img(item));
      }
      this.setState({
        open,
        images: [...clone],
      })
    }
  }

  render() {
    const classCustom = {
      "modal": "modal-custom upload-image-modal",
      "closeButton": "close-button-custom",
    };

    const { images, uploading } = this.state;

    const renderPreview = () => {
      return images.map((item, index) => {
        return <div key={index + 'image'} className="col-md-6 image-block">
          <img src={item} alt=""/>
          <button onClick={this.handleRemove.bind(this, index)} className="btn btn-sm btn-danger">Remove this image</button>
        </div>
      })
    };

    return (
      <Modal classNames={classCustom} open={this.state.open} onClose={this.onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Upload image</h5>
          </div>
          <div className="modal-body">
            <div className="form-group group-file-upload">
              <input onChange={this.handleFilesChange} type="file" id="upload-images" name="upload-images" multiple="true" style={{ display: 'none' }}/>
              <label className="btn btn-danger" htmlFor="upload-images"><i className="fa fa-camera"> </i> Upload Images</label>
            </div>
            <div className="row preview">
              {renderPreview()}
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={this.onSubmit} disabled={uploading} className="btn btn-sm btn-primary">
              <i className="fa fa-dot-circle-o"> </i> { uploading ? 'Saving...' : 'Save' }
            </button>
            <button onClick={this.onClose} className="btn btn-sm btn-secondary">
              <i className="fa fa-ban"> </i> Close
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/custom/UploadImageModal.js